import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import _ from 'lodash';
import * as actions from '../actions';
import * as c from '../constants';
import BillerInfo from '../component/BillerInfo';
import logo from '../../../assets/img/logo.png';
import icn_back from '../../../assets/img/icons/back.svg';
import icn_next from '../../../assets/img/icons/next.svg';

class BillerSummary extends Component {
  static propTypes = {
    error: PropTypes.instanceOf(Object).isRequired,
    isLoading: PropTypes.bool.isRequired,
    history: PropTypes.instanceOf(Object).isRequired,
    location: PropTypes.instanceOf(Object).isRequired,
    // partner: PropTypes.instanceOf(Object).isRequired,
    pay: PropTypes.func.isRequired,
    inquiry_no: PropTypes.string.isRequired,
  }

  state = {
    biller: {},
    payload: {},
    summary: [],
  }

  componentDidMount() {
    const { location } = this.props;
    const state = location.state || {};
    const { biller, payload } = state;
    if (!biller || !payload) {
      const { history } = this.props;
      history.push(location.pathname.replace('/summary', ''));
      return;
    }
    const billerMeta = Array.isArray(biller.meta) ? biller.meta : _.get(biller, 'meta.parameters') || [];
    const findMeta = key => (billerMeta || []).find(x => x.field === key) || {};
    let summary = [];
    _.forOwn(state.payload, (v, k) => {
      summary = summary.concat([{
        id: k,
        label: findMeta(k).label || '-',
        value: v,
      }]);
    });
    this.setState({
      biller,
      payload,
      summary,
    });
  }

  componentDidUpdate(props) {
    const { error: oldError } = props;
    const { error: newError } = this.props;
    if (!_.isEqual(oldError, newError)) {
      this.handleError();
    }
  }

  handleError = () => {
    const { error } = this.props;
    if (_.isEmpty(error)) return;
    const { inquiry_no, history } = this.props;
    const { biller, payload } = this.state;
    history.push({
      pathname: `/${inquiry_no}/billers/${biller.code}`,
      state: { biller, payload },
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { payload, biller } = this.state;
    const { pay, inquiry_no } = this.props;
    pay(inquiry_no, {
      biller_code: biller.code,
      ...payload,
    }, this.payCallback);
  }

  payCallback = ({ data }) => {
    const { inquiry_no, history } = this.props;
    history.push({
      pathname: `/${inquiry_no}/success`,
      state: {
        redirect_url: _.get(data, 'data.redirect_url'),
      },
    });
  }

  render() {
    const { biller, payload, summary } = this.state;
    const {
      isLoading, location,
    } = this.props;
    return (
      <div className="container outer-wrapper">
        <div className="row mb-3">
          <div className="col mx-auto inner-wrapper">
            {/* <div className="text-center">
              <img src={logo} className="img-fluid logo mb-2" alt="" />
              <h6>MultiSys Payment Facility</h6>
            </div> */}
            <div className="pb-3 main-container mt-3">
              <form onSubmit={this.handleSubmit}>
                {/* { isLoading && <div className="generic-list-loader shadow-lg" /> } */}
                {isLoading
                  && (
                    <div className="loader-wrapper">
                      <div className="d-flex justify-content-center h-100">
                        <div className="align-self-center text-center">
                          <div className="loading">
                            <img src={logo} className="logo-loader" alt="" />
                          </div>
                          <div className="load-bar">
                            <div className="h-load-bar">
                              <div
                                className="load-step"
                                // style={{ background: partner.header_color || '#d03d40' }}
                              />
                            </div>
                            <p><i>Processing...</i></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                }
                <div>
                  <BillerInfo data={biller} />
                  <div className="mt-4 px-5">
                    <table className="table table-stripped table-receipt">
                      <tbody>
                        {summary.map(item => (
                          <tr key={item.id}>
                            <td className="text-muted" width="35%"><small>{item.label}</small></td>
                            <td className="text-right w-50">{item.value}</td>
                          </tr>
                        ))}
                        {/* <tr>
                          <td className="text-muted"><small>Service Fee</small></td>
                          <td className="text-right">20.00</td>
                        </tr>
                        <tr>
                          <td className="text-muted"><small>Total</small></td>
                          <td className="text-right text-success"><b>1,220.00</b></td>
                        </tr> */}
                      </tbody>
                    </table>
                  </div>
                  <hr />
                  <div className="d-flex justify-content-center">
                    <Link
                      className="btn btn-secondary btn-lg mr-2"
                      to={{ pathname: location.pathname.replace('/summary', ''), state: { biller, payload } }}
                    >
                      <span className="icon">
                        <img src={icn_back} className="img-fluid" alt="" />
                      </span>
                      <span className="text">
                        Back
                      </span>
                    </Link>
                    <button
                      className="btn btn-primary btn-lg"
                      type="submit"
                    >
                      <span className="text">
                        Pay Now
                      </span>
                      <span className="icon">
                        <img src={icn_next} className="img-fluid" alt="" />
                      </span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col text-center">
            <p className="mb-0 text-muted"><small>MultiSys Payment Facility v.1.0</small></p>
            <small className="text-muted">www.MultiSyscorp.com</small>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ api }, { match }) => ({
  inquiry_no: match.params.inquiry_no,
  biller_code: match.params.biller_code,
  partner: _.get(api, `${c.INQUIRE}.item.partner`) || {},
  error: _.get(api, `error.${c.PAY}.response`) || {},
  isLoading: api.loading.indexOf(c.PAY) > -1,
});

export default withRouter(connect(mapStateToProps, actions)(BillerSummary));
